import axios from 'axios'

const preproductionServerUrl = process.env.VUE_APP_ENV === 'preproduction'
  ? process.env.VUE_APP_SERVER_URL
  : null

const instance = axios.create({
  baseURL: preproductionServerUrl || process.env.SERVER_URL,
  headers: {
    'Content-Type': 'application/json'
  }
})

export default instance



// WEBPACK FOOTER //
// ./src/services/api.js